export function activityTypeFilter(category) {
  switch (category) {
    case '会议':
      return "会议";
    case '讲座':
      return "讲座";
    default:
      return "会议";
  }
}

export function newsTypeFilter(category) {
  switch (category) {
    case '本院新闻':
      return "本院新闻";
    case '业界新闻':
      return "业界新闻";
    default:
      return "本院新闻";
  }
}

export function socoalServiceTypeFilter(category) {
  switch (category) {
    case '社区服务':
      return "社区服务";
    case '党团建设':
      return "党团建设";
    default:
      return "社区服务";
  }
}

export function jobTypeFilter(category) {
  switch (category) {
    case '教师招聘':
      return "教师招聘";
    case '职员招聘':
      return "职员招聘";
    default:
      return "教师招聘";
  }
}